import { createAction } from "@reduxjs/toolkit";

import { ChatActions } from "../../type/chat.actions.types";
import {
  GetChatRoomsActionData,
  GetNotificationActionData,
  GetRoomMessagesActionData,
  LoadMoreRoomMessagesActionData,
  MarkRoomAsSeenActionData,
  SyncChatRoomsActionData,
} from "../../type/queries.types";

export const chatNotificationAction = createAction(
  ChatActions.getChatNotification,
  (data: GetNotificationActionData) => ({
    payload: { getOneUnseenRoomQuery: data.getOneUnseenRoomQuery },
  })
);

export const getChatRoomsAction = createAction(ChatActions.getChatRooms, (data: GetChatRoomsActionData) => ({
  payload: { getChatRoomsQuery: data.getChatRoomsQuery, userId: data.userId },
}));

export const getChatRoomMessagesAction = createAction(
  ChatActions.getChatRoomMessages,
  (data: GetRoomMessagesActionData) => ({
    payload: { roomId: data.roomId, getRoomMessagesQuery: data.getRoomMessagesQuery },
  })
);

export const loadMoreRoomMessagesAction = createAction(
  ChatActions.loadMoreRoomMessages,
  (data: LoadMoreRoomMessagesActionData) => ({
    payload: { roomId: data.roomId, loadMoreRoomMessagesQuery: data.loadMoreRoomMessagesQuery },
  })
);

export const markRoomAsSeenAction = createAction(ChatActions.markRoomAsSeen, (data: MarkRoomAsSeenActionData) => ({
  payload: { roomId: data.roomId, userRef: data.userRef },
}));

export const syncChatRoomsAction = createAction(ChatActions.syncChatRooms, (data: SyncChatRoomsActionData) => ({
  payload: { userId: data.userId, getChatRoomsQuery: data.getChatRoomsQuery },
}));

export const syncRoomMessagesAction = createAction(ChatActions.roomMessagesSync, (data: any) => ({
  payload: { roomId: data.roomId, clubRef: data.clubRef, userId: data.userId },
}));
